const getBaseViewFields = (
  baseView: FleetOps.BaseView,
): FleetOps.BaseViewField[] => {
  return Object.values(baseView.fields).filter(
    (bfv) => !!bfv,
  ) as FleetOps.BaseViewField[];
};

export default getBaseViewFields;
